import { call, put } from "redux-saga/effects";
import api from "src/util/api";
import { showErrorNotification } from "src/util/notifications";
import { fetchReplenishmentJobConfigUpdateSummarySuccess } from "./action";
import { REPLENISHMENT_JOB_CONFIG_URL } from "src/util/constants/api.constants";

export function* fetchReplenishmentJobConfiguration(p0: {}): Generator {
  try {
    let url = REPLENISHMENT_JOB_CONFIG_URL.REPLENISHMENT_JOB_CONFIG;
    const data: any = yield call(api.get, url);
    yield put(fetchReplenishmentJobConfigUpdateSummarySuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function UpdateReplenishmentPause(payload: any) {
  let url = REPLENISHMENT_JOB_CONFIG_URL.UPDATE_REPLENISHMENT_JOB_CONFIG;
  return api.post(url, payload);
}